<footer class="w-full z-40 bg-gray-900 mx-auto rounded-bl rounded-br shadow border-b border-gray-200">
    <div class="container max-w-[80%] mx-auto flex justify-between items-center">
      <span class="font-semibold w-full text-xl text-white tracking-tight centering_item">
        <p>連絡先 : me(at)laminne33569.net</p>
        <p>(atをアットマークに置換してください)</p>
        <ul class="flex justify-center">
          <li class="github"> <a href="https://github.com/mct-joken" target="_blank"><img class="w-[1.85rem] h-[1.85rem]" src="github_icon.png" alt="github"></a></li>
          <li class="twitter"><a href="https://twitter.com/mct_joken" target="_blank"><img class="w-8 h-8" src="twitter_icon.png" alt="twitter"></a></li>
        </ul>
        <p>(c)松江高専 情報科学研究部</p>
      </span>
  </div>
</footer>

<style>
  p {
    @apply text-base text-center;
  }
  ul li {
    @apply list-none items-center;
  }
</style>

